<template>
  <v-card
    class="status-tile"
    :class="{ 'status-tile--clickable': clickable }"
    @click="onClick"
  >
    <v-card-text>
      <v-layout row wrap align-center>
        <v-flex xs3 class="text-xs-center">
          <v-icon :color="resolvedColor" size="28">{{ resolvedIcon }}</v-icon>
        </v-flex>
        <v-flex xs9>
          <div class="caption text-uppercase grey--text text--darken-1">{{ title }}</div>
          <div class="headline">{{ headline }}</div>
          <div v-if="subline" class="caption grey--text text--darken-1">{{ subline }}</div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { statusColor, statusIcon } from './status-mapping'

export default {
  name: 'diagnostics-status-tile',
  props: {
    title: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'unknown'
    },
    headline: {
      type: String,
      default: '-'
    },
    subline: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    resolvedColor () {
      return statusColor(this.status)
    },
    resolvedIcon () {
      return statusIcon(this.status)
    }
  },
  methods: {
    onClick () {
      if (!this.clickable) {
        return
      }
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.status-tile {
  height: 100%;
  border-left: 4px solid transparent;
}

.status-tile--clickable {
  cursor: pointer;
}

.status-tile--clickable:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
}
</style>
